/**
 * Nome de status e de itens do catálogo de tickets no idioma do sistema. As listas vêm do banco em
 * português, com chave_i18n; item sem chave (criado depois pela tela de cadastro) mostra o nome gravado.
 */
export function rotuloCatalogo(vm, item, campoNome) {
    if (!item) return '';
    const chave = item.chave_i18n ? `ticketCatalogo.${item.chave_i18n}` : null;
    if (chave && vm.$te(chave)) return vm.$t(chave);
    return item[campoNome] != null ? item[campoNome] : '';
}
